import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { statCardSurface } from "@/components/common/statCardSurface";

/**
 * Icon-box + label + big-number stat card. The shared replacement for the
 * per-entity StatCards duplicated across Companies / Organizations / Users /
 * Locations stat islands.
 */
export interface StatCardProps {
  label: string;
  value: ReactNode;
  icon: LucideIcon;
  loading?: boolean;
  className?: string;
}

export function StatCard({
  label,
  value,
  icon: Icon,
  loading,
  className,
}: StatCardProps) {
  if (loading) return <Skeleton className={cn("h-32 w-full", className)} />;
  return (
    <Card className={cn(statCardSurface, className)}>
      <CardHeader className="flex flex-row gap-2 p-2 pb-0">
        <div className="rounded-md border p-1.5">
          <Icon className="h-4 w-4 text-(--color-text-secondary)" />
        </div>
        <CardTitle className="pt-1 text-sm font-medium text-(--color-text-secondary)">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <span className="text-5xl font-medium">{value}</span>
      </CardContent>
    </Card>
  );
}
